<template>
  <div class="atributos-dinamicos-admin">
    <el-tabs
      v-model="activeSubTab"
      type="border-card"
    >
      <!-- TAB: DEFINICIONES DE ATRIBUTOS -->
      <el-tab-pane
        label="Atributos"
        name="definiciones"
      >
        <DefinicionesTab
          :definiciones="definiciones"
          :loading="loadingDefiniciones"
          @open-modal="openDefinicionModal()"
          @edit="openDefinicionModal"
          @delete="handleDeleteDefinicion"
        />
      </el-tab-pane>

      <!-- TAB: ASOCIACIONES ENTIDAD-ATRIBUTO -->
      <el-tab-pane
        label="Asociaciones"
        name="relaciones"
      >
        <AsociacionesTab
          :entidades="entidadesFormateadas"
          :relaciones="relaciones"
          :entidades-bd="entidades"
          :loading="loadingRelaciones"
          @open-relacion-modal="openRelacionModal"
          @update-relacion="handleUpdateRelacion"
          @delete-relacion="handleDeleteRelacion"
          @open-criterios-modal="openCriteriosModal"
        />
      </el-tab-pane>
    </el-tabs>

    <!-- MODAL: CREAR/EDITAR DEFINICIÓN -->
    <DefinicionModal
      v-model:visible="definicionModalVisible"
      :form="definicionForm"
      :saving="saving"
      @update:form="definicionForm = $event"
      @save="handleSaveDefinicion"
    />

    <!-- MODAL: GESTIONAR OPCIONES (Mantenido por compatibilidad, puede eliminarse) -->
    <el-dialog
      v-model="opcionesModalVisible"
      :title="`Opciones: ${currentDefinicion?.Etiqueta}`"
      width="700px"
      @close="currentDefinicion = null"
    >
      <div class="opciones-manager">
        <el-table
          v-loading="loadingOpciones"
          :data="opciones"
          border
          stripe
          max-height="400"
        >
          <el-table-column
            prop="Etiqueta"
            label="Etiqueta"
            min-width="200"
          >
            <template #default="{ row }">
              <el-input
                v-if="row.editing"
                v-model="row.Etiqueta"
                size="small"
                @blur="handleSaveOpcion(row)"
                @keyup.enter="handleSaveOpcion(row)"
              />
              <span v-else>{{ row.Etiqueta }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Clave"
            label="Clave"
            width="150"
          >
            <template #default="{ row }">
              <el-input
                v-if="row.editing"
                v-model="row.Clave"
                size="small"
                @blur="handleSaveOpcion(row)"
                @keyup.enter="handleSaveOpcion(row)"
              />
              <span v-else>{{ row.Clave || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Orden"
            label="Orden"
            width="100"
          >
            <template #default="{ row }">
              <el-input-number
                ref="inputRef"
                v-model="row.Orden"
                :min="0"
                :max="999"
                :formatter="formatter"
                :parser="parser"
                size="small"
                @focus="handleFocus"
                @blur="handleBlur(row.Orden)"
                @change="handleSaveOpcion(row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="Acciones"
            width="120"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                v-if="!row.editing"
                size="small"
                text
                :icon="Edit"
                @click="row.editing = true"
              />
              <el-popconfirm
                title="¿Eliminar esta opción?"
                confirm-button-text="Sí"
                cancel-button-text="No"
                @confirm="handleDeleteOpcion(row.Codigo)"
              >
                <template #reference>
                  <el-button
                    size="small"
                    text
                    type="danger"
                    :icon="Delete"
                  />
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>

        <div class="mt-4">
          <el-form
            :inline="true"
            @submit.prevent="handleAddOpcion"
          >
            <el-form-item>
              <el-input
                v-model="nuevaOpcion.Etiqueta"
                placeholder="Etiqueta"
                style="width: 200px"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="nuevaOpcion.Clave"
                placeholder="Clave (opcional)"
                style="width: 150px"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="handleAddOpcion"
              >
                <i class="el-icon-plus"></i> Agregar
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <template #footer>
        <el-button @click="opcionesModalVisible = false">Cerrar</el-button>
      </template>
    </el-dialog>

    <!-- MODAL: ASOCIAR ATRIBUTO -->
    <el-dialog
      v-model="relacionModalVisible"
      title="Asociar Atributo a Entidad"
      width="500px"
      @close="resetRelacionForm"
    >
      <el-form
        ref="relacionFormRef"
        :model="relacionForm"
        :rules="relacionRules"
        label-position="top"
      >
        <el-form-item
          label="Atributo"
          prop="CodigoAtributo"
        >
          <el-select
            v-model="relacionForm.CodigoAtributo"
            placeholder="Seleccionar atributo"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="def in definicionesDisponibles"
              :key="def.Codigo"
              :label="`${def.Etiqueta} (${def.Clave})`"
              :value="def.Codigo"
            />
          </el-select>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Orden">
              <el-input-number
                ref="inputRef"
                v-model="relacionForm.Orden"
                :min="0"
                :max="999"
                :formatter="formatter"
                :parser="parser"
                style="width: 100%"
                @focus="handleFocus"
                @blur="handleBlur(relacionForm.Orden)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-checkbox
                v-model="relacionForm.Requerido"
                class="mt-8"
              >
                Requerido
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <el-button @click="relacionModalVisible = false">Cancelar</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="handleSaveRelacion"
        >
          Asociar
        </el-button>
      </template>
    </el-dialog>

    <!-- MODAL: CRITERIOS DE VISUALIZACIÓN -->
    <CriteriosModal
      v-model:visible="criteriosModalVisible"
      :relacion="criteriosModal.relacion"
      :nombre-entidad="criteriosModal.nombreEntidad"
      :es-material="criteriosModal.esMaterial"
      :es-proceso="criteriosModal.esProceso"
      :editable="criteriosModal.editable"
      :elemento-tipos="criteriosModal.elementoTipos"
      :material-categorias="criteriosModal.materialCategorias"
      :procesos="criteriosModal.procesos"
      :modulos-sistema="modulosSistema"
      :loading="loadingCriteriosModal"
      :saving="saving"
      @close="resetCriteriosModal"
      @guardar-elemento-tipo="guardarCriteriosElementoTipo"
      @guardar-material-categoria="guardarCriteriosMaterialCategoria"
      @guardar-procesos="guardarCriteriosProcesos"
    />
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
} from 'vue';
import {
  ElMessage,
  ElNotification,
} from 'element-plus';
import {
  Delete,
  Edit,
} from '@element-plus/icons-vue';
import atributosDinamicosService from '@/services/atributos_dinamicos_service.js';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(null);

// Subcomponentes
import DefinicionesTab from './atributos-dinamicos/DefinicionesTab.vue';
import AsociacionesTab from './atributos-dinamicos/AsociacionesTab.vue';
import DefinicionModal from './atributos-dinamicos/DefinicionModal.vue';
import CriteriosModal from './atributos-dinamicos/CriteriosModal.vue';

// ══════════════════════════════════════════════════════════════════════════
// STATE
// ══════════════════════════════════════════════════════════════════════════

const activeSubTab = ref('definiciones');

// Módulos del sistema (bitfield)
const modulosSistema = ref([
  { nombre: 'Solicitud', valor: 1 },
  { nombre: 'Cotización', valor: 2 },
  { nombre: 'ET', valor: 4 },
  { nombre: 'OT', valor: 8 },
]);

// Entidades desde el backend
const entidades = ref([]);
const entidadSeleccionada = ref(null);

// Computed: formatear entidades para compatibilidad con componente hijo
const entidadesFormateadas = computed(() => {
  return entidades.value
    .filter((e) => e.Activo)
    .map((e) => ({
      codigo: e.Nombre,
      nombre: e.Nombre,
    }));
});

// Definiciones
const definiciones = ref([]);
const loadingDefiniciones = ref(false);
const definicionModalVisible = ref(false);
const definicionForm = ref({
  Etiqueta: '',
  Clave: '',
  Descripcion: '',
  Tipo: 'string',
  ValorPorDefecto: null,
  Opciones: [],
});

// Opciones originales al abrir el modal (para detectar eliminaciones)
const opcionesOriginales = ref([]);

// Opciones
const currentDefinicion = ref(null);
const opciones = ref([]);
const loadingOpciones = ref(false);
const opcionesModalVisible = ref(false);
const nuevaOpcion = ref({ Etiqueta: '', Clave: '' });

// Relaciones
const relaciones = ref([]);
const loadingRelaciones = ref(false);
const relacionModalVisible = ref(false);
const relacionFormRef = ref(null);
const relacionForm = ref({
  CodigoAtributo: null,
  CodigoEntidad: null,
  Requerido: false,
  Orden: 0,
});

const relacionRules = {
  CodigoAtributo: [{ required: true, message: 'Seleccione un atributo', trigger: 'change' }],
};

const saving = ref(false);

// Modal de criterios de visualización
const criteriosModalVisible = ref(false);
const loadingCriteriosModal = ref(false);
const criteriosModal = ref({
  relacion: null,
  nombreEntidad: '',
  esMaterial: false,
  esProceso: false,
  activeTab: 'elementoTipos',
  elementoTipos: [],
  materialCategorias: [],
  procesos: [],
  editable: false,
});

// Filtros de búsqueda en tabs de criterios (se limpian al cerrar el modal)
const filtroElementoTipo = ref('');
const filtroMaterialCategoria = ref('');
const filtroProceso = ref('');

// ══════════════════════════════════════════════════════════════════════════
// COMPUTED
// ══════════════════════════════════════════════════════════════════════════

const definicionesDisponibles = computed(() => {
  if (!entidadSeleccionada.value) return definiciones.value;
  const asignadas = relaciones.value
    .filter((r) => r.CodigoEntidad === entidadSeleccionada.value)
    .map((r) => r.CodigoAtributo);
  return definiciones.value.filter((d) => !asignadas.includes(d.Codigo));
});

// ══════════════════════════════════════════════════════════════════════════
// LIFECYCLE
// ══════════════════════════════════════════════════════════════════════════

onMounted(async () => {
  await loadEntidades();
  await loadDefiniciones();
  await loadAllRelaciones();
});

// ══════════════════════════════════════════════════════════════════════════
// MÉTODOS: CARGAR DATOS
// ══════════════════════════════════════════════════════════════════════════

async function loadEntidades() {
  try {
    entidades.value = await atributosDinamicosService.getEntidades();
  } catch (error) {
    console.error('Error al cargar entidades:', error);
    ElMessage.error('Error al cargar entidades');
  }
}

async function loadDefiniciones() {
  loadingDefiniciones.value = true;
  try {
    definiciones.value = await atributosDinamicosService.getDefiniciones();
  } catch (error) {
    console.error('Error al cargar definiciones:', error);
    ElMessage.error('Error al cargar atributos');
  } finally {
    loadingDefiniciones.value = false;
  }
}

async function loadAllRelaciones() {
  loadingRelaciones.value = true;
  try {
    const promesas = entidades.value
      .filter((e) => e.Activo)
      .map(async (entidad) => {
        return await atributosDinamicosService.getRelaciones(entidad.Codigo);
      });

    const resultados = await Promise.all(promesas);
    relaciones.value = resultados.flat();
  } catch (error) {
    console.error('Error al cargar relaciones:', error);
    ElMessage.error('Error al cargar asociaciones');
  } finally {
    loadingRelaciones.value = false;
  }
}

async function loadOpciones(codigoAtributo) {
  loadingOpciones.value = true;
  try {
    opciones.value = await atributosDinamicosService.getOpciones(codigoAtributo);
    opciones.value.forEach((o) => (o.editing = false));
  } catch (error) {
    console.error('Error al cargar opciones:', error);
    ElMessage.error('Error al cargar opciones');
  } finally {
    loadingOpciones.value = false;
  }
}

// ══════════════════════════════════════════════════════════════════════════
// MÉTODOS: DEFINICIONES
// ══════════════════════════════════════════════════════════════════════════

function openDefinicionModal(definicion = null) {
  if (definicion) {
    let valorPorDefecto = definicion.ValorPorDefecto;
    if (valorPorDefecto && typeof valorPorDefecto === 'string') {
      try {
        valorPorDefecto = JSON.parse(valorPorDefecto);
      } catch (e) {
        console.warn('ValorPorDefecto no es JSON válido:', valorPorDefecto);
      }
    }

    const opciones = definicion.AtributoOpcion ? [...definicion.AtributoOpcion] : [];

    definicionForm.value = {
      ...definicion,
      ValorPorDefecto: valorPorDefecto,
      Opciones: opciones,
    };

    opcionesOriginales.value = opciones.map((op) => ({ ...op }));
  } else {
    definicionForm.value = {
      Etiqueta: '',
      Clave: '',
      Descripcion: '',
      Tipo: 'string',
      ValorPorDefecto: null,
      Opciones: [],
    };
    opcionesOriginales.value = [];
  }
  definicionModalVisible.value = true;
}

async function handleSaveDefinicion(errorClaveDuplicada) {
  try {
    if (
      (definicionForm.value.Tipo === 'select' || definicionForm.value.Tipo === 'multiselect') &&
      !definicionForm.value.Opciones.length
    ) {
      ElMessage.warning('Debe agregar al menos una opción para atributos de tipo selección');
      return;
    }

    saving.value = true;

    // Separar opciones y datos del formulario
    const { Opciones, ...formData } = definicionForm.value;

    // Eliminar campos que no van en el DTO
    const camposExcluidos = [
      'AtributoOpcion',
      'AtributoEntidadRelacion',
      'EntidadPrincipal',
      'UsuarioCreacion',
      'UsuarioActualizacion',
      'FechaCreacion',
      'FechaActualizacion',
      'Version',
      'Codigo',
      'CodigoUsuarioCreacion',
      'CodigoUsuarioActualizacion',
      'CodigoEntidadPrincipal',
    ];

    camposExcluidos.forEach((campo) => delete formData[campo]);

    if (definicionForm.value.Codigo) {
      const updateData = {
        Clave: formData.Clave,
        Etiqueta: formData.Etiqueta,
        Descripcion: formData.Descripcion || null,
        Tipo: formData.Tipo,
        ValorPorDefecto: formData.ValorPorDefecto,
        ConfiguracionUI: formData.ConfiguracionUI,
        Activo: formData.Activo,
      };

      await atributosDinamicosService.updateDefinicion(definicionForm.value.Codigo, updateData);

      const opcionesActuales = Opciones.filter((op) => op.Codigo);
      const codigosActuales = new Set(opcionesActuales.map((op) => op.Codigo));
      const opcionesEliminadas = opcionesOriginales.value.filter(
        (op) => op.Codigo && !codigosActuales.has(op.Codigo),
      );

      if (opcionesEliminadas.length > 0) {
        for (const opcion of opcionesEliminadas) {
          try {
            await atributosDinamicosService.deleteOpcion(opcion.Codigo);
          } catch (deleteError) {
            console.error('Error al eliminar opción:', deleteError);
            ElMessage.warning(`No se pudo eliminar la opción "${opcion.Etiqueta}"`);
          }
        }
      }

      if (Opciones && Opciones.length > 0) {
        const nuevasOpciones = Opciones.filter((op) => !op.Codigo);
        if (nuevasOpciones.length > 0) {
          for (const opcion of nuevasOpciones) {
            try {
              const opcionData = {
                CodigoAtributo: definicionForm.value.Codigo,
                Etiqueta: opcion.Etiqueta,
                Clave: opcion.Clave || null,
                Orden: opcion.Orden || 0,
                Activo: opcion.Activo !== false,
              };
              await atributosDinamicosService.createOpcion(opcionData);
            } catch (opcionError) {
              console.error('Error al crear opción:', opcionError);
              ElMessage.error(`Error al crear opción "${opcion.Etiqueta}"`);
            }
          }
        }
      }

      ElMessage.success('Atributo actualizado correctamente');
    } else {
      const definicionCreada = await atributosDinamicosService.createDefinicion(formData);

      if (Opciones && Opciones.length > 0) {
        for (const opcion of Opciones) {
          try {
            const opcionData = {
              CodigoAtributo: definicionCreada.Codigo,
              Etiqueta: opcion.Etiqueta,
              Clave: opcion.Clave || null,
              Orden: opcion.Orden || 0,
              Activo: opcion.Activo !== false,
            };
            await atributosDinamicosService.createOpcion(opcionData);
          } catch (opcionError) {
            console.error('Error al crear opción:', opcionError);
            ElMessage.error(`Error al crear opción "${opcion.Etiqueta}"`);
          }
        }
      }

      ElMessage.success('Atributo creado correctamente con sus opciones');
    }

    definicionModalVisible.value = false;
    await loadDefiniciones();
  } catch (error) {
    if (error !== false) {
      console.error('Error al guardar definición:', error);
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Error al guardar el atributo';

      const esClaveDuplicada =
        errorMessage.toLowerCase().includes('clave') &&
        (errorMessage.toLowerCase().includes('existe') ||
          errorMessage.toLowerCase().includes('duplicad') ||
          errorMessage.toLowerCase().includes('unique'));

      if (esClaveDuplicada) {
        errorClaveDuplicada.value = errorMessage;
        ElMessage.error('La clave ya existe en el sistema');
      } else {
        ElNotification({
          title: 'Error al guardar atributo',
          message: errorMessage,
          type: 'error',
          duration: 5000,
        });
      }
    }
  } finally {
    saving.value = false;
  }
}

async function handleDeleteDefinicion(codigo) {
  try {
    await atributosDinamicosService.deleteDefinicion(codigo);
    ElMessage.success('Atributo eliminado correctamente');
    // Recargar definiciones y relaciones para actualizar la grilla
    await Promise.all([loadDefiniciones(), loadAllRelaciones()]);
  } catch (error) {
    console.error('Error al eliminar definición:', error);
    ElMessage.error('Error al eliminar el atributo');
  }
}

// ══════════════════════════════════════════════════════════════════════════
// MÉTODOS: OPCIONES (para el modal standalone)
// ══════════════════════════════════════════════════════════════════════════

async function handleAddOpcion() {
  if (!nuevaOpcion.value.Etiqueta.trim()) {
    ElMessage.warning('Ingrese una etiqueta');
    return;
  }

  try {
    const data = {
      CodigoAtributo: currentDefinicion.value.Codigo,
      Etiqueta: nuevaOpcion.value.Etiqueta.trim(),
      Clave: nuevaOpcion.value.Clave.trim() || null,
      Orden: opciones.value.length,
    };

    await atributosDinamicosService.createOpcion(data);
    ElMessage.success('Opción agregada');

    nuevaOpcion.value = { Etiqueta: '', Clave: '' };
    await loadOpciones(currentDefinicion.value.Codigo);
  } catch (error) {
    console.error('Error al agregar opción:', error);
    ElMessage.error('Error al agregar la opción');
  }
}

async function handleSaveOpcion(opcion) {
  opcion.editing = false;

  try {
    const { Codigo, Etiqueta, Clave, Orden } = opcion;
    await atributosDinamicosService.updateOpcion(Codigo, { Etiqueta, Clave, Orden });
  } catch (error) {
    console.error('Error al guardar opción:', error);
    ElMessage.error('Error al guardar la opción');
  }
}

async function handleDeleteOpcion(codigo) {
  try {
    await atributosDinamicosService.deleteOpcion(codigo);
    ElMessage.success('Opción eliminada');
    await loadOpciones(currentDefinicion.value.Codigo);
  } catch (error) {
    console.error('Error al eliminar opción:', error);
    ElMessage.error('Error al eliminar la opción');
  }
}

// ══════════════════════════════════════════════════════════════════════════
// MÉTODOS: RELACIONES
// ══════════════════════════════════════════════════════════════════════════

function openRelacionModal(codigoEntidad) {
  const entidadBd = entidades.value.find((e) => e.Nombre === codigoEntidad);
  if (!entidadBd) {
    ElMessage.error('Entidad no encontrada');
    return;
  }

  entidadSeleccionada.value = entidadBd.Codigo;
  const relacionesEntidad = relaciones.value.filter((r) => r.CodigoEntidad === entidadBd.Codigo);

  relacionForm.value = {
    CodigoAtributo: null,
    CodigoEntidad: entidadBd.Codigo,
    Requerido: false,
    Orden: relacionesEntidad.length,
  };
  relacionModalVisible.value = true;
}

function resetRelacionForm() {
  relacionFormRef.value?.clearValidate();
}

async function handleSaveRelacion() {
  try {
    await relacionFormRef.value.validate();
    saving.value = true;

    await atributosDinamicosService.createRelacion(relacionForm.value);
    ElMessage.success('Atributo asociado correctamente');

    relacionModalVisible.value = false;
    await loadAllRelaciones();
  } catch (error) {
    if (error !== false) {
      console.error('Error al asociar atributo:', error);
      ElMessage.error('Error al asociar el atributo');
    }
  } finally {
    saving.value = false;
  }
}

async function handleUpdateRelacion(relacion) {
  try {
    const { Codigo, Requerido, Orden, ValorPorDefecto } = relacion;
    await atributosDinamicosService.updateRelacion(Codigo, {
      Requerido,
      Orden,
      ValorPorDefecto,
    });
  } catch (error) {
    console.error('Error al actualizar relación:', error);
    ElMessage.error('Error al actualizar la asociación');
  }
}

async function handleDeleteRelacion(codigo) {
  try {
    await atributosDinamicosService.deleteRelacion(codigo);
    ElMessage.success('Asociación eliminada');
    await loadAllRelaciones();
  } catch (error) {
    console.error('Error al eliminar relación:', error);
    ElMessage.error('Error al eliminar la asociación');
  }
}

// ══════════════════════════════════════════════════════════════════════════
// MÉTODOS: CRITERIOS DE VISUALIZACIÓN
// ══════════════════════════════════════════════════════════════════════════

async function openCriteriosModal(relacion, nombreEntidad) {
  criteriosModal.value.relacion = relacion;
  criteriosModal.value.nombreEntidad = nombreEntidad;
  criteriosModal.value.esMaterial = nombreEntidad === 'Material';
  criteriosModal.value.esProceso = nombreEntidad === 'Proceso';
  criteriosModal.value.activeTab = 'elementoTipos';

  await loadCriteriosModal();
  criteriosModalVisible.value = true;
}

async function loadCriteriosModal() {
  if (!criteriosModal.value.relacion) return;

  loadingCriteriosModal.value = true;
  try {
    const codigoRelacion = criteriosModal.value.relacion.Codigo;

    const elementoTipos = await atributosDinamicosService.getAllElementosTipo();
    const criteriosET =
      await atributosDinamicosService.getCriteriosElementoTipoUnificado(codigoRelacion);

    const criteriosMap = {};
    criteriosET.forEach((c) => {
      criteriosMap[c.CodigoElementoTipo] = {
        ModuloVisible: c.ModuloVisible || 0,
        ModuloEditable: c.ModuloEditable || 0,
      };
    });

    criteriosModal.value.elementoTipos = elementoTipos.map((et) => ({
      Codigo: et.Codigo,
      Descripcion: et.Descripcion,
      ModuloVisible: criteriosMap[et.Codigo]?.ModuloVisible || 0,
      ModuloEditable: criteriosMap[et.Codigo]?.ModuloEditable || 0,
    }));

    if (criteriosModal.value.esMaterial) {
      const materialCategorias = await atributosDinamicosService.getAllMaterialCategorias();
      const criteriosMC =
        await atributosDinamicosService.getCriteriosMaterialCategoriaUnificado(codigoRelacion);

      const criteriosMapMC = {};
      criteriosMC.forEach((c) => {
        criteriosMapMC[c.CodigoMaterialCategoria] = {
          ModuloVisible: c.ModuloVisible || 0,
          ModuloEditable: c.ModuloEditable || 0,
        };
      });

      criteriosModal.value.materialCategorias = materialCategorias.map((mc) => ({
        Codigo: mc.Codigo,
        Descripcion: mc.Descripcion,
        ModuloVisible: criteriosMapMC[mc.Codigo]?.ModuloVisible || 0,
        ModuloEditable: criteriosMapMC[mc.Codigo]?.ModuloEditable || 0,
      }));
    }

    // Si es Proceso, cargar Procesos
    if (criteriosModal.value.esProceso) {
      const procesos = await atributosDinamicosService.getAllProcesos();
      const criteriosProc =
        await atributosDinamicosService.getCriteriosProcesosUnificado(codigoRelacion);

      const criteriosMapProc = {};
      criteriosProc.forEach((c) => {
        criteriosMapProc[c.CodigoProceso] = {
          ModuloVisible: c.ModuloVisible || 0,
          ModuloEditable: c.ModuloEditable || 0,
        };
      });

      criteriosModal.value.procesos = procesos.map((proc) => ({
        Codigo: proc.Codigo,
        Descripcion: proc.Descripcion,
        ModuloVisible: criteriosMapProc[proc.Codigo]?.ModuloVisible || 0,
        ModuloEditable: criteriosMapProc[proc.Codigo]?.ModuloEditable || 0,
      }));
    }
  } catch (error) {
    console.error('Error al cargar criterios del modal:', error);
    ElMessage.error('Error al cargar criterios de visualización');
  } finally {
    loadingCriteriosModal.value = false;
  }
}

async function guardarCriteriosElementoTipo() {
  try {
    saving.value = true;

    const criterios = criteriosModal.value.elementoTipos.map((et) => ({
      codigoElementoTipo: et.Codigo,
      moduloVisible: et.ModuloVisible,
      moduloEditable: et.ModuloEditable,
    }));

    await atributosDinamicosService.updateCriteriosElementoTipoUnificado(
      criteriosModal.value.relacion.Codigo,
      criterios,
    );

    ElMessage.success('Criterios de elemento tipo actualizados correctamente');
  } catch (error) {
    console.error('Error al guardar criterios de elemento tipo:', error);
    ElMessage.error('Error al actualizar criterios');
  } finally {
    saving.value = false;
  }
}

async function guardarCriteriosMaterialCategoria() {
  try {
    saving.value = true;

    const criterios = criteriosModal.value.materialCategorias.map((mc) => ({
      codigoMaterialCategoria: mc.Codigo,
      moduloVisible: mc.ModuloVisible,
      moduloEditable: mc.ModuloEditable,
    }));

    await atributosDinamicosService.updateCriteriosMaterialCategoriaUnificado(
      criteriosModal.value.relacion.Codigo,
      criterios,
    );

    ElMessage.success('Criterios de categorías de material actualizados correctamente');
  } catch (error) {
    console.error('Error al guardar criterios de categorías de material:', error);
    ElMessage.error('Error al actualizar criterios');
  } finally {
    saving.value = false;
  }
}

async function guardarCriteriosProcesos() {
  try {
    saving.value = true;

    const criterios = criteriosModal.value.procesos.map((proc) => ({
      codigoProceso: proc.Codigo,
      moduloVisible: proc.ModuloVisible,
      moduloEditable: proc.ModuloEditable,
    }));

    await atributosDinamicosService.updateCriteriosProcesosUnificado(
      criteriosModal.value.relacion.Codigo,
      criterios,
    );

    ElMessage.success('Criterios de procesos actualizados correctamente');
  } catch (error) {
    console.error('Error al guardar criterios de procesos:', error);
    ElMessage.error('Error al actualizar criterios');
  } finally {
    saving.value = false;
  }
}

function resetCriteriosModal() {
  criteriosModal.value.relacion = null;
  criteriosModal.value.nombreEntidad = '';
  criteriosModal.value.esMaterial = false;
  criteriosModal.value.esProceso = false;
  criteriosModal.value.activeTab = 'elementoTipos';
  criteriosModal.value.elementoTipos = [];
  criteriosModal.value.materialCategorias = [];
  criteriosModal.value.procesos = [];
  filtroElementoTipo.value = '';
  filtroProceso.value = '';
  filtroMaterialCategoria.value = '';
}
</script>

<style scoped>
.atributos-dinamicos-admin {
  padding: 0;
}

.opciones-manager {
  min-height: 200px;
}

.mt-4 {
  margin-top: 16px;
}

.mt-8 {
  margin-top: 32px;
}
</style>
